import type { StudentGuideDTO } from '@ui/shared/util-api';
import { MapItem } from '@ui/shared/util-map';
import type { EducationalBranch } from './educational-branch';
import type { EducationalFundingMeasureGroup } from './educational-funding-measure-group';
import type { SchoolMapItem } from './school-map-item';

export class StudentGuideMapItem extends MapItem implements SchoolMapItem {
    public readonly typeLabel: string = '';
    public readonly imagePath: string;
    public readonly placeholderPath?: string;
    public readonly thumbnailPath: string;
    public readonly accessibilityFeatures: Array<string> = [];
    public readonly administrationContact: string = '';
    public readonly specialFeatures: string = '';
    public readonly careServices: Array<string> = [];
    public readonly weblink: string = '';
    public readonly unlinkedLanguages: Array<string> = [];
    public readonly educationalBranches: Array<EducationalBranch> = [];
    public readonly educationalBranchesLabel: string = '';
    public readonly doEducationalBranchesHaveLanguages: boolean = false;
    public readonly measureGroups: Array<EducationalFundingMeasureGroup> = [];

    constructor(mapItem: StudentGuideDTO) {
        super(
            mapItem,
            `id-${ mapItem.id }-type-guide`,
        );

        this.iconPath = mapItem.icon ?? '';
        this.iconLabel = 'Schulweghelfer';
        this.imagePath = mapItem.image?.thumbs?.detail ?? mapItem.image?.image ?? '';
        this.thumbnailPath = mapItem.image?.thumbs?.preview ?? this.imagePath;
        this.placeholderPath = '/assets/images/student_guide.png';
    }
}
